import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import EmailIcon from "@mui/icons-material/Email";
import PinterestIcon from "@mui/icons-material/Pinterest";

const Footer = () => {
  const shareUrl = encodeURIComponent(window.location.href);
  const shareText = encodeURIComponent("Check out my favorite tool on MyFreshTools!");

  const socialLinks = [
    {
      icon: <WhatsAppIcon />,
      url: `https://api.whatsapp.com/send?text=${shareText}%20${shareUrl}`,
      label: "Share on WhatsApp",
      color: "#25D366",
    },
    {
      icon: <TwitterIcon />,
      url: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareText}`,
      label: "Share on Twitter",
      color: "#1DA1F2",
    },
    {
      icon: <FacebookIcon />,
      url: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
      label: "Share on Facebook",
      color: "#1877F2",
    },
    {
      icon: <LinkedInIcon />,
      url: `https://www.linkedin.com/shareArticle?url=${shareUrl}&title=${shareText}`,
      label: "Share on LinkedIn",
      color: "#0077B5",
    },
    {
      icon: <TelegramIcon />,
      url: `https://t.me/share/url?url=${shareUrl}&text=${shareText}`,
      label: "Share on Telegram",
      color: "#0088CC",
    },
    {
      icon: <PinterestIcon />,
      url: `https://pinterest.com/pin/create/button/?url=${shareUrl}&description=${shareText}`,
      label: "Share on Pinterest",
      color: "#BD081C",
    },
    {
      icon: <EmailIcon />,
      url: `mailto:?subject=${encodeURIComponent("Check out MyFreshTools")}&body=${shareText}%20${shareUrl}`,
      label: "Share via Email",
      color: "#D44638",
    },
  ];

  return (
    <Box component="footer" sx={{ backgroundColor: "#1e1e1e", color: "#cfcfcf", py: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          {/* MyFreshTools Description */}
          <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: "white" }}>
              MYFRESHTOOLS
            </Typography>
            <Box sx={{ maxWidth: 260, mx: "auto" }}>
              <Typography variant="body2" color="grey.400">
                MyFreshTools helps creators, marketers, and developers boost productivity with smart tools
                for YouTube, Google search, content creation, and more — all in one place.
              </Typography>
            </Box>
          </Grid>

          {/* Popular Tools */}
          <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: "white" }}>
              POPULAR TOOLS
            </Typography>
            {[
              ["Playlist Export", "/youtube/playlistExport"],
              ["Thumbnail Downloader", "/youtube/thumbnailDownloader"],
              ["Export Search Results", "/youtube/searchResultsExport"],
              ["Video Tag Generator", "/youtube/tagGenerator"],
              ["Channel Backup", "/youtube/channelBackUp"],
              ["Tags Rank Checker", "/youtube/tags-rank-checker"],
            ].map(([label, path]) => (
              <Link
                key={label}
                href={path}
                color="inherit"
                underline="hover"
                sx={{ display: "block", mb: 0.5 }}
              >
                {label}
              </Link>
            ))}
          </Grid>

          {/* Useful Links */}
          <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: "white" }}>
              USEFUL LINKS
            </Typography>
            <Link
              href="/privacy-policy"
              color="inherit"
              underline="hover"
              sx={{ display: "block", mb: 0.5 }}
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms-of-use"
              color="inherit"
              underline="hover"
              sx={{ display: "block", mb: 0.5 }}
            >
              Terms of Use
            </Link>
            <Link
              href="https://app.getreditus.com/marketplace/myfreshtools"
              color="inherit"
              underline="hover"
              sx={{ display: "block", mb: 0.5 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Affiliates(50%💰)
            </Link>
          </Grid>

          {/* Contact + Social Share */}
          <Grid item xs={12} sm={6} md={3} sx={{ textAlign: "center" }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: "white" }}>
              CONTACT
            </Typography>
            <Link
              href="/contact"
              color="inherit"
              underline="hover"
              sx={{ display: "block", mb: 0.5 }}
            >
              Contact Us
            </Link>
            <Box mt={2}>
              <Typography variant="caption" display="block" color="grey.400">
                Share the tools you ❤️
              </Typography>
              {socialLinks.map(({ icon, url, label, color }) => (
                <IconButton
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  sx={{
                    color: color,
                    "&:hover": {
                      backgroundColor: "transparent",
                      opacity: 0.8,
                    },
                  }}
                >
                  {icon}
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>

        {/* Bottom bar */}
        <Box mt={6} textAlign="center" sx={{ color: "grey.600" }}>
          <Typography variant="body2">
            Copyright © {new Date().getFullYear()}{" "}
            <Link href="https://myfreshtools.com" underline="hover" color="inherit">
              myfreshtools.com
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
